import React, { Component } from 'react';
import { connect } from 'react-redux';
import { map, sortBy } from 'lodash';
import SfaForm from '../SfaForm';
import { withRouter } from '../router/withRouter';
import { Field, reduxForm } from 'redux-form';
import OkCancelModal from '../../components/OkCancelModal';

import {
    error,
    getRetailerTypeOptions,
    initCurrentGameHighlight,
    saveGameHighlight,
    setLoading,
    updateCurrentGameHighlight,
    updateNewGameChecked,
} from '../../redux/actions';

import { periods } from '../../constants/gameHighlightPeriod';
import CalendarPicker from '../CalendarPicker';
import { PLabel, PSelect } from '../form';
import { Checkbox } from 'semantic-ui-react';
import { endDatebeforeStartDate } from '../../constants/validate';

const disabledInputBoxStyle = (newGame) => {
    return newGame ? { backgroundColor: '#C7C8CC', opacity: 0.4 } : {};
};

export class CreateGameHighlights extends Component {
    state = {
        startDateError: null,
        endDateError: null,
        confirmationModal: false,
    };

    async componentDidMount() {
        const { currentGameHighlight } = this.props;
        this.props.setLoading(true);
        this.props.getRetailerTypeOptions();

        if (currentGameHighlight) {
            this.props.updateNewGameChecked(
                currentGameHighlight.period ? true : false,
            );
        }
        this.props.setLoading(false);
    }

    submitForm = async (val) => {
        try {
            const request = this.createRequest();
            this.props.setLoading(true);

            await this.props.saveGameHighlight(request);
            this.setState({ confirmationModal: false });
            this.props.returnOnSuccess();
            this.props.initCurrentGameHighlight();
            this.props.setLoading(false);
        } catch (err) {
            this.setState({ confirmationModal: false });
        }
    };

    createRequest = () => {
        const {
            gameHighlightsOptions: { newGameChecked },
            currentGameHighlight,
        } = this.props;
        let request = {
            id: currentGameHighlight.id,
            name: currentGameHighlight.name,
            colourId: currentGameHighlight.colourId,
            retailerTypes: currentGameHighlight.retailerTypes,
        };
        if (newGameChecked) {
            request.period = currentGameHighlight.period;
        } else {
            request.startDate = currentGameHighlight.startDate;
            request.endDate = currentGameHighlight.endDate;
            request.itemId = currentGameHighlight.itemId;
        }
        return request;
    };

    handleConfirmationModal = () => {
        this.setState({ confirmationModal: !this.state.confirmationModal });
    };

    handleDateChange = (value, formattedValue, field) => {
        const {
            currentGameHighlight: { startDate, endDate },
        } = this.props;

        if (field === 'startDate') {
            this.setState({
                startDateError: endDatebeforeStartDate(formattedValue, endDate),
                endDateError: false,
            });
            this.props.updateCurrentGameHighlight({
                startDate: formattedValue,
            });
        }
        if (field === 'endDate') {
            this.setState({
                startDateError: false,
                endDateError: endDatebeforeStartDate(startDate, formattedValue),
            });
            this.props.updateCurrentGameHighlight({ endDate: formattedValue });
        }
    };

    handleColourChange = (val) => {
        this.props.updateCurrentGameHighlight({ colourId: val });
    };

    handlePeriodChange = (val) => {
        this.props.updateCurrentGameHighlight({ period: val });
    };

    handleRetailerTypeChange = (val) => {
        this.props.updateCurrentGameHighlight({ retailerTypes: val });
    };

    handleNewGame = (val) => {
        const newGame = val.checked;
        this.props.updateNewGameChecked(newGame);
    };

    handleNameChange = (val) => {
        this.props.updateCurrentGameHighlight({ name: val?.target?.value });
    };

    handleGameDropDown = (val) => {
        this.props.updateCurrentGameHighlight({ itemId: val });
    };

    handleCheckRetailerType = (value, formattedValue, e, data) => {
        const {
            currentGameHighlight: { retailerTypes },
        } = this.props;
        if (!formattedValue.checked) {
            const filteredArray = retailerTypes.filter(
                (item) => item !== formattedValue.value,
            );
            this.props.updateCurrentGameHighlight({
                retailerTypes: filteredArray,
            });
        } else if (
            formattedValue.checked &&
            !retailerTypes?.includes(formattedValue.value)
        ) {
            const newArray = [...retailerTypes, formattedValue.value];
            this.props.updateCurrentGameHighlight({ retailerTypes: newArray });
        }
    };

    submitDisableCheck = () => {
        const { startDateError, endDateError } = this.state;
        const {
            currentGameHighlight: {
                name,
                startDate,
                endDate,
                period,
                colourId,
                itemId,
            },
            gameHighlightsOptions: { newGameChecked },
        } = this.props;

        if (!name || !colourId) {
            return true;
        }
        if (newGameChecked && !period) {
            return true;
        }
        if (!newGameChecked && (!(startDate && endDate) || !itemId?.length)) {
            return true;
        }
        if (startDateError || endDateError) {
            return true;
        }
        return false;
    };

    render() {
        const { startDateError, endDateError, confirmationModal } = this.state;
        const {
            retailerTypeOptions,
            returnToList,
            handleSubmit,
            highlightsColours,
            gameHighlightsOptions: { newGameChecked, loading, gameList },
            currentGameHighlight: {
                name,
                startDate,
                endDate,
                period,
                colourId,
                itemId,
                retailerTypes,
            },
            localizeDetail,
        } = this.props;

        return (
            <SfaForm
                headerText={localizeDetail.gameHighlight}
                onCancel={returnToList}
                submitButtonText={localizeDetail.saveButton}
                showSaveCancel={true}
                onSubmit={this.handleConfirmationModal}
                submitIsDisabled={this.submitDisableCheck()}
                loading={loading}>
                <OkCancelModal
                    header={localizeDetail.gameHighlight}
                    body={localizeDetail.okModalBody}
                    cancelFunction={this.handleConfirmationModal}
                    okFunction={handleSubmit(this.submitForm)}
                    isOpen={confirmationModal}
                    okText={localizeDetail.saveButton}
                />

                <PLabel text={localizeDetail.highlightName + ' *'} />
                <input
                    value={name}
                    onChange={this.handleNameChange}
                    style={{
                        width: '100%',
                        height: 50,
                        marginBottom: 10,
                        paddingLeft: 10,
                    }}
                    maxLength={50}
                />

                <Field
                    label={localizeDetail.colour + ' *'}
                    onChange={this.handleColourChange}
                    component={PSelect}
                    placeholder="Select Colour"
                    name="colour"
                    options={map(
                        highlightsColours,
                        ({ id, colourName, colourCode }) => {
                            return {
                                text: (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyItems: 'center',
                                            gap: 5,
                                        }}>
                                        <div
                                            style={{
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '100%',
                                                backgroundColor: colourCode,
                                            }}
                                        />
                                        {`${colourName?.trim().toString()}`}
                                    </div>
                                ),
                                value: id?.toString(),
                            };
                        },
                    )}
                    defValue={colourId?.toString()}
                    clearable={true}
                />
                <Checkbox
                    key={newGameChecked}
                    label={localizeDetail.newGame}
                    onChange={(val, data) => this.handleNewGame(data)}
                    checked={newGameChecked}></Checkbox>
                <Field
                    disabled={newGameChecked}
                    style={disabledInputBoxStyle(newGameChecked)}
                    onChange={this.handleGameDropDown}
                    component={PSelect}
                    placeholder="Select Games"
                    name="itemId"
                    options={map(
                        sortBy(gameList, 'name'),
                        ({ id, name, reference }) => ({
                            text: `${reference} - ${name}`,
                            value: id.toString(),
                        }),
                    )}
                    defValue={itemId}
                    clearable={true}
                    multiple={true}
                    clearVal={newGameChecked}
                />
                <CalendarPicker
                    disabled={newGameChecked}
                    name={'startDate'}
                    value={startDate}
                    handleChange={this.handleDateChange}
                    labelText={localizeDetail.startDate}
                    clearVal={newGameChecked}
                />
                {startDateError && (
                    <span className="error-text">
                        <i>Start Date cannot be after End Date</i>
                    </span>
                )}
                <CalendarPicker
                    disabled={newGameChecked}
                    value={endDate}
                    name={'endDate'}
                    handleChange={this.handleDateChange}
                    labelText={localizeDetail.endDate}
                    clearVal={newGameChecked}
                />
                {endDateError && (
                    <span className="error-text">
                        <i>End Date cannot be before Start Date</i>
                    </span>
                )}

                <Field
                    label={localizeDetail.period}
                    disabled={!newGameChecked}
                    onChange={this.handlePeriodChange}
                    style={disabledInputBoxStyle(!newGameChecked)}
                    component={PSelect}
                    placeholder="Select Period"
                    name="period"
                    options={map(periods, (period) => {
                        return {
                            text:
                                period === '1'
                                    ? `${period} week`
                                    : period === '-1'
                                      ? 'Never'
                                      : `${period} weeks`,
                            value: period,
                        };
                    })}
                    defValue={[period?.toString()]}
                    clearable={true}
                    clearVal={!newGameChecked}
                />
                <PLabel text={localizeDetail.retailerTypes} />
                {retailerTypeOptions.map((type) => {
                    return (
                        <div key={type}>
                            <ul style={{ paddingLeft: 0 }}>
                                <li style={{ listStyleType: 'none' }}>
                                    <Checkbox
                                        key={type}
                                        value={type.value}
                                        label={type.label}
                                        onChange={this.handleCheckRetailerType}
                                        checked={retailerTypes?.includes(
                                            type.value,
                                        )}></Checkbox>
                                </li>
                            </ul>
                        </div>
                    );
                })}
            </SfaForm>
        );
    }
}

const mapStateToProps = ({
    gameHighlightsOptions,
    retailerTypeOptions: { options },
    currentGameHighlight,
}) => {
    return {
        gameHighlightsOptions,
        retailerTypeOptions: options,
        currentGameHighlight,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getRetailerTypeOptions: () => dispatch(getRetailerTypeOptions()),
        errorMsg: ({ msg, target }) => dispatch(error({ msg, target })),
        updateCurrentGameHighlight: (state) =>
            dispatch(updateCurrentGameHighlight(state)),
        updateNewGameChecked: (checked) =>
            dispatch(updateNewGameChecked(checked)),
        initCurrentGameHighlight: () => dispatch(initCurrentGameHighlight()),
        setLoading: (loading) => dispatch(setLoading(loading)),
        saveGameHighlight: (payload) => dispatch(saveGameHighlight(payload)),
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(
        reduxForm({
            form: 'CreateGameHighlightsForm',
            enableReinitialize: true,
        })(CreateGameHighlights),
    ),
);
